import PlayIcon from '@/components/Icon/PlayIcon';
import IconButton from '@/components/IconButton/IconButton';
import LabelBackground from '@/components/LabelBackground/LabelBackground';
import useUrlHistorySyncedOpenState from '@/hooks/useUrlHistorySyncedOpenState';
import { Video as VideoType } from '@/lib/apiTypes';
import cn from '@/lib/cs';
import { motion } from 'framer-motion';
import { FC } from 'react';
import VideoDialog from './VideoDialog';

const Video: FC<{
	video: VideoType;
	aspectRatio?: 'landscape' | 'portrait';
	onPlay?: () => void;
}> = ({ video, aspectRatio = 'landscape', onPlay }) => {
	const [isVideoOpened, setIsVideoOpened] = useUrlHistorySyncedOpenState();

	return (
		<>
			<motion.div
				className={cn(
					'relative mx-auto block aspect-video w-full max-w-56',
					aspectRatio === 'portrait' && 'aspect-[3/4]',
				)}
				onClick={() => {
					setIsVideoOpened(true);
					onPlay?.();
				}}
				whileTap={{ scale: 0.95 }}
				tabIndex={-1}>
				<img
					src={video.thumbnail.data?.attributes.url}
					alt={video.thumbnail.data?.attributes.alternativeText ?? ''}
					className={cn(
						'size-full -translate-y-2 object-cover',
						aspectRatio === 'portrait' && 'object-top',
					)}
					style={{
						WebkitMaskImage: `url("/assets/masks/blob_card_1.svg?video")`,
						maskImage: `url("/assets/masks/blob_card_1.svg?video")`,
						WebkitMaskSize: '100% 100%',
						maskSize: '100% 100%',
						maskRepeat: 'no-repeat',
					}}
				/>

				<p className="absolute -bottom-2 -start-4 max-w-44 text-xl text-gray-50">
					<span className="relative block rotate-2 px-2 pb-1 pt-0.5">
						<LabelBackground className="text-gray-950" />
						<span className="relative z-10 line-clamp-1 max-w-full text-ellipsis break-words">
							{video.title}
						</span>
					</span>
				</p>

				<IconButton
					icon={<PlayIcon />}
					aria-label="Speel video"
					title={`Video "${video.title}" afspelen`}
					className="absolute -bottom-2 -end-4"
					variant="secondary"
					onClick={(event) => {
						event.stopPropagation();
						setIsVideoOpened(true);
					}}
				/>
			</motion.div>

			<VideoDialog
				video={video}
				isVideoOpened={isVideoOpened}
				setIsVideoOpened={setIsVideoOpened}
			/>
		</>
	);
};

export default Video;
